import { render, staticRenderFns } from "./ServiceAddOn.vue?vue&type=template&id=2116dc34"
import script from "./ServiceAddOn.vue?vue&type=script&lang=js"
export * from "./ServiceAddOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports